module.exports = __webpack_public_path__ + "static/img/msy-sph.4db6eef.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msy-sph.jpg
// module id = uCHf
// module chunks = 110